module.exports = __webpack_public_path__ + "static/media/instagramR.6a12c981.png";